import axios from '@axios'

export default {
  loadTable(pageConfig) {
    return axios.get('/financeiro/periodo_vigencias', { params: pageConfig })
  },
  loadCombo() {
    return axios.get('/financeiro/periodo_vigencias/lista')
  },
  insert(data) {
    return axios.post('/financeiro/periodo_vigencias', data)
  },
  update(id, data) {
    return axios.put(`/financeiro/periodo_vigencias/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/financeiro/periodo_vigencias/${id}`)
  },
}
